const URL = {
  BASE_URL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000/api'
}
export default URL;
